import React, { useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { Action } from "redux";
import { DeleteWarningIcon } from "../../../../components/ui/icons";
import useNotification from "../../../../components/notification/useNotification";
import { useSpinner } from "../../../../customHooks";
import { Status } from "../../../../common/constants";
import {
  deleteSuperAdminDevice,
  resetDeleteSuperAdminDeviceStatus,
  selector as deleteSuperAdminDeviceApi,
} from "./superAdminDeleteDeviceSlice";

interface IProps {
  deviceId: string;
  deviceDisplayName: string;
  selectedOrganizationId: string;
  selectedOrganizationName: string;
  onDeleteSuccess: () => void;
  showModel: boolean;
  handleClose: () => void;
}

const SuperAdminDeleteDeviceModal = ({
  deviceId,
  deviceDisplayName,
  selectedOrganizationId,
  selectedOrganizationName,
  onDeleteSuccess,
  showModel,
  handleClose,
}: IProps) => {
  const dispatch: ThunkDispatch<any, undefined, Action> = useDispatch();
  const deleteDeviceState = useSelector(deleteSuperAdminDeviceApi);

  const { showSuccessNotification, showWarningNotification } =
    useNotification();

  useSpinner(deleteDeviceState.status);

  const isDeleting = deleteDeviceState.status === Status.PENDING;

  useEffect(() => {
    if (deleteDeviceState.status === Status.SUCCESS) {
      showSuccessNotification("You have Reclaimed the device successfully.");
      onDeleteSuccess();
      handleClose();
      dispatch(resetDeleteSuperAdminDeviceStatus());
    } else if (deleteDeviceState.status === Status.FAILED) {
      showWarningNotification("Failed to reclaim device");
      dispatch(resetDeleteSuperAdminDeviceStatus());
    }
  }, [deleteDeviceState.status]);

  const handleDeleteButtonClick = () => {
    dispatch(
      deleteSuperAdminDevice({
        deviceId,
        organizationId: selectedOrganizationId,
      })
    );
  };

  const handleModalClose = () => {
    dispatch(resetDeleteSuperAdminDeviceStatus());
    handleClose();
  };

  return (
    <Modal
      show={showModel}
      onHide={handleModalClose}
      className="modal-container"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <div className="delete-heading">
            <DeleteWarningIcon />
            <h1>Reclaim</h1>
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>
          Are you sure you want to <b>Reclaim</b> this device?
        </p>

        <div className="delete-device-details">
          <p>
            <strong>Device Name:</strong> {deviceDisplayName}
          </p>
          <p>
            <strong>Device ID:</strong> {deviceId}
          </p>
          <p>
            <strong>Organization:</strong> {selectedOrganizationName}
          </p>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button className="btn-cancel" onClick={handleModalClose}>
          Cancel
        </Button>

        <Button
          className="btn-delete"
          onClick={handleDeleteButtonClick}
          disabled={isDeleting}
        >
          Reclaim
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SuperAdminDeleteDeviceModal;